import { CmpTable, SectionTitle } from "../../shared";
import SubComponent from "./SubComponent";
import { GET_ALL_ICC_CONFIG } from "./query";

const IccConfigList = () => {
    const columns = [
        {
            accessorKey: "appAid",
            header: "Application ID",
        },
        {
            accessorKey: "aemEnvironment",
            header: "App Env Path",
        },
        {
            accessorKey: "veevaInstanceType",
            header: "Instance",
            cell: (cell) => cell.getValue().veevaInstanceType,
        },
        {
            accessorKey: "aemCountryNode",
            header: "Country",
            cell: (cell) => cell.getValue().aemCountryNode,
        },
        {
            accessorKey: "localCode",
            header: "Local Code",
        },
    ];

    const renderSubComponent = (data) => <SubComponent data={data.row.original} />;

    return (
        <>
            <SectionTitle
                title="ICC Configurations"
                buttonUrl="/global-config/abbvie-id/icc-config/create"
                backUrl="/global-config/abbvie-id"
            />

            <CmpTable
                QUERY={GET_ALL_ICC_CONFIG}
                headers={columns}
                renderSubComponent={renderSubComponent}
                dataPath="allIccEnvironmentConfigurations"
            />
        </>
    );
};

export default IccConfigList;
